var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".settings-icon-white{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "settings-icon-white",
    d: "M49.13,30.48l-4.72-3.59a15.93,15.93,0,0,0,0-3.78l4.73-3.6a2.22,2.22,0,0,0,.56-2.87L44.79,8.38a2.36,2.36,0,0,0-2.84-1L36.38,9.56A18.9,18.9,0,0,0,33,7.67l-.85-5.75A2.26,2.26,0,0,0,29.92,0H20.08a2.25,2.25,0,0,0-2.26,1.9L17,7.67a20.34,20.34,0,0,0-3.34,1.89L8.05,7.38a2.3,2.3,0,0,0-2.82,1L.31,16.64a2.2,2.2,0,0,0,.56,2.88l4.72,3.59a15.93,15.93,0,0,0,0,3.78L.87,30.48a2.21,2.21,0,0,0-.56,2.88l4.91,8.26a2.34,2.34,0,0,0,2.83,1l5.57-2.18A18.9,18.9,0,0,0,17,42.33l.86,5.75A2.25,2.25,0,0,0,20.08,50h9.84a2.25,2.25,0,0,0,2.26-1.9L33,42.33a20.34,20.34,0,0,0,3.34-1.89L42,42.62a2.31,2.31,0,0,0,2.82-1l4.93-8.32A2.21,2.21,0,0,0,49.13,30.48ZM25,35.42A10.57,10.57,0,0,1,14.3,25,10.57,10.57,0,0,1,25,14.58,10.56,10.56,0,0,1,35.69,25,10.57,10.57,0,0,1,25,35.42Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsWhite);
export default __webpack_public_path__ + "static/media/settings-white.fce94b30.svg";
export { ForwardRef as ReactComponent };